












import Vue from 'vue';
import { WebRequestStatus } from '../models';

export default Vue.extend({
  props: {
    status: {
      type: Number, // An enum
      default: -1
    }
  },

  computed: {
    isReady(): boolean {
      return this.status === -1 || this.status === WebRequestStatus.READY;
    },
    isInProgress(): boolean {
      return this.status === WebRequestStatus.IN_PROGRESS;
    }
  }
});
